'use strict';

angular.module('dokiv')
  .filter('reverse', function() {
    return function(items) {
      return items.slice().reverse();
    };
  });


//////////////////
// WEBPACK FOOTER
// ./scripts/app/ReverseFilter.js
// module id = 249
// module chunks = 0